<template>
  <div class="flex items-center justify-center flex-col gap-1 md:min-w-12" :data-testid="`base-button-container-${level || 'default'}`">
    <button 
      :class="[ `${size}`, `${level}`, { 'w-full': fullWidth }, { selected: selected }, { disabled: disabled}]" 
      class="button md:min-w-12 max-w-[100%] gap-2"
      :data-testid="`base-button-${level || 'default'}${size ? '-' + size : ''}${disabled ? '-disabled' : ''}${selected ? '-selected' : ''}`"
    >
      <slot />
      <span v-if="text" :class="{ 'hidden md:flex': noTextMobile, 'uppercase': textUppercase}" :data-testid="`base-button-text-${level || 'default'}`">{{ text }}</span>
    </button>
    <span class="button-label" v-if="label" :data-testid="`base-button-label-${level || 'default'}`">{{ label }}</span>
  </div>
</template>
<script setup>
import {computed, defineProps} from 'vue';

const props = defineProps({
  label: {
    type: String,
    required: false
  },
  text: {
    type: String,
    required: false
  },
  level: {
    type: String,
    required: false,
    default: 'grayed'
  },
  roundedImage: {
    type: Boolean,
    default: false,
    required: false
  },
  size: {
    type: String,
    required: false,
    default: 'big'
  },
  noTextMobile: {
    type: Boolean,
    required: false,
    default: false
  },
  textUppercase: {
    type: Boolean,
    required: false,
    default: false
  },
  fullWidth: {
    type: Boolean,
    required: false,
    default: false
  },
  selected: {
    type: Boolean,
    required: false,
    default: false
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false
  }
})

const imageRounded = computed(() => {
  let rounded = '0%';

  if (props.roundedImage) {
    rounded = '50%';
  }

  return rounded;
})

</script>

<style lang="scss" >
  .button {
    img {
      border-radius:  v-bind('imageRounded');
    }
  }
</style>